module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core.module/components/letter-icon/letter-icon.component.css
// module id = ./src/app/core.module/components/letter-icon/letter-icon.component.css
// module chunks = main